// Converts a UTC date string to an ISO8601 string in the user's local timezone
export default (dateString: string): string => {
  try {
    // Normalize input to ensure it's treated as UTC
    const normalized = /Z|[+-]\d{2}(?::\d{2})?$/.test(dateString) ? dateString : `${dateString}Z`
    const utcDate = new Date(normalized)
    if (isNaN(utcDate.getTime())) throw new Error('Invalid date format or value')

    // Get local date parts
    const pad = (n: number) => n.toString().padStart(2, '0')
    const year = utcDate.getFullYear()
    const month = pad(utcDate.getMonth() + 1)
    const day = pad(utcDate.getDate())
    const hours = pad(utcDate.getHours())
    const minutes = pad(utcDate.getMinutes())
    const seconds = pad(utcDate.getSeconds())

    // Get local timezone offset in minutes and convert to ±HH:MM
    const offset = -utcDate.getTimezoneOffset()
    const sign = offset >= 0 ? '+' : '-'
    const absOffset = Math.abs(offset)
    const offsetHours = pad(Math.floor(absOffset / 60))
    const offsetMinutes = pad(absOffset % 60)
    const tzString = `${sign}${offsetHours}:${offsetMinutes}`

    // Construct ISO8601 string in local time
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${tzString}`
  } catch (error) {
    console.error('Error converting date:', error instanceof Error ? error.message : String(error))
    return ''
  }
}
